/**
 * Splits a Uint8Array payload into fixed-size chunks.
 * Each chunk will be no longer than MAX_FRAGMENT_PAYLOAD_SIZE bytes.
 *
 * @param payload - The full message payload to split
 * @param maxFragmentSize - Maximum size for each fragment in bytes
 * @returns An array of Uint8Array fragments
 */
export function splitPayloadIntoFragments(
  payload: Uint8Array,
  maxFragmentSize: number
): Uint8Array[] {
  const fragments: Uint8Array[] = [];

  for (let offset = 0; offset < payload.length; offset += maxFragmentSize) {
    const end = Math.min(offset + maxFragmentSize, payload.length);
    fragments.push(payload.subarray(offset, end));
  }

  return fragments;
}